import { to, cloneObject, formatAddressFromForm } from '../../../lib/helpers';
import { resolveMilitaryStatusCode } from '../../../lib/data';
import agencies from '../../../agency-config/agencies';

// Vendors
import { push } from 'connected-react-router';
import moment from 'moment';

// Requests
import { userVerifyAddressRequest } from '../../../backend/userRequests';
import { getAppFromId , verifyRenewalNotice, ernoUpdate,lookupAppLinkRequest, dmvAddressChangeTransactRequest} from '../../../backend/agencyRequests';

import {
  checkRequestFailure,
  handleRequestFailure,
  ERRORS_MAP,
} from '../../../lib/validation';

// Actions
import {
  APP_TRANSACTION_IDS,
  storeBasicInfo,
  clearAppData,
} from '../../app/appActions';
//import { selectDonationDetails } from './dmvSelectors';
import { openModal } from '../../modal/modalActions';

const DMV_AGENCY_ID = agencies.find(
  ({ agency }) => agency.agencyShortName === 'DMV'
).agency.agencyId;

export const DMV_DMVRR_CLEAR_DATA = '[DMV] DMVRR - Clear Data';
export const DMV_SET_FROM_DEEP_LINK = '[DMV] Set From Deep Link';
export const DMV_RENEW_LICENSE = '[DMV] Renew License';
export const DMV_STORE_SELECTED_VEHICLE = '[DMV] Store Selected Vehicle';
export const DMV_STORE_APP_PROFILE = '[DMV] Store App Profile';
export const DMV_STORE_LOOKUP = '[DMV] Store Lookup';
export const DMV_APPLINK_REQUEST = '[DMV] Applink verify';
export const DMV_STORE_FULL_PROFILE = '[DMV] Store Full Profile';
export const DMV_STORE_APP_INSURANCE = '[DMV] Store Insutance Information';
export const DMV_UPDATE_FEE_DETAILS = '[DMV] Update Fee Details';
export const DMV_UPDATE_DONATION_DETAILS = '[DMV] Update Donation Details';
export const DMV_UPDATE_VEHICLE_COLOR_DETAILS =
  '[DMV] Updating Vehicle Color Details';
export const DMV_UPDATE_ERNO = '[DMV] Update Erno';
export const DMV_UPDATE_MILITARY_STATUS = '[DMV] Update Military Status';
export const DMV_UPDATE_IMC_NO = '[DMV] Update ImcNo';
export const DMV_UPDATE_MAILING_ADDRESS = '[DMV] Update Mailing Address';
export const DMV_UPDATE_RENEWAL_TERM = '[DMV] Update Renewal Term';
export const DMV_COMMERCIAL_VEHICLE =
  '[DMV] Store commercial vehicle indicator';
export const DMV_STORE_COUNTY_CODE = '[DMV] Store County code';

export const DMV_UPDATE_PAYMENT_WAS_MADE = 'TRUE';
export const DMV_UPDATE_IS_OUT_OF_STATE = 'DMV_UPDATE_IS_OUT_OF_STATE';
export const DMV_IS_VEHICLE_CERTIFIED = 'DMV_IS_VEHICLE_CERTIFIED';

export const DMV_MELISA_SUCCESS = 'SUCCESS';
export const DMV_MELISA_CONTINUE = 'CONTINUE';
export const DMV_MELISA_WARNING = 'WARNING';
export const DMV_MELISA_ERROR = 'ERROR';
export const DMV_MELISA_ADDRESS_TWO_MISSING = 'ADDRESS_TWO_MISSING';
export const DMV_MELISA_ADDRESS_TWO_INVALID = 'ADDRESS_TWO_INVALID';
export const DMV_MELISA_ADDRESS_NOT_VERIFIED = 'ADDRESS_NOT_VERIFIED';
export const DMV_MELISA_INVALID_ADDRESS = 'INVALID_ADDRESS';
export const DMV_STORE_EXEMPTION = 'DMV STORE EXEMPTION';
export const DMV_STORE_RENEWAL_TERM = 'DMV STORE RENEWAL TERM';

export const renewDMVRegistration = data => {
  return async function(dispatch) {
    await dispatch({
      type: DMV_RENEW_LICENSE,
      payload: data,
    });
    await dispatch(storeBasicInfo(data));
    await dispatch(push('/dmvrr'));
  };
};

export const stickerTrackerDMV = data => {
  return async function(dispatch) {
    dispatch({
      type: DMV_STORE_APP_PROFILE,
      payload: data,
    });

    dispatch(push('/dmv/sticker-tracker'));
  };
};

export const editRenewalNotice = data => {
  return async function(dispatch) {
    dispatch({
      type: DMV_STORE_APP_PROFILE,
      payload: data,
    });

    dispatch(push('/dmv/edit-renewal-notice'));
  };
};

export const changeMailingAddress = data => dispatch => {
  dispatch({ type: DMV_STORE_SELECTED_VEHICLE, payload: data });
  return dispatch(push('/dmvac'));
};

export const updateFeeDetails = payload => {
  return {
    type: DMV_UPDATE_FEE_DETAILS,
    payload,
  };
};

export const updateDonationDetails = payload => {
  return async (dispatch, getStore) => {
    const donations = getStore().dmv.appProfile.donationDetails;

    donations.forEach(donation => {
      if (payload[donation.feeCode.replace('-', '')] !== '')
        donation.feeAmount = payload[donation.feeCode.replace('-', '')];
    });

    return {
      type: DMV_UPDATE_DONATION_DETAILS,
      donations,
    };
  };
};

export const updateVehicleColors = payload => {
  return async (dispatch, getStore) => {
    const vehicle = getStore().dmv.appProfile.vehicle;

    if (
      vehicle.majorColorCode !== payload.majorColor.value ||
      vehicle.minorColorCode !== payload.minorColor.value
    ) {
      vehicle.majorColorCode = payload.majorColor.value;
      vehicle.minorColorCode = payload.minorColor.value;
      return {
        type: DMV_UPDATE_VEHICLE_COLOR_DETAILS,
        vehicle,
      };
    }
  };
};

export const updatePaymentWasMade = (status = false) => {
  return {
    type: DMV_UPDATE_PAYMENT_WAS_MADE,
    status: status,
  };
};

export const updateErno = payload => {
  return {
    type: DMV_UPDATE_ERNO,
    payload,
  };
};

export const updateMilitaryStatus = payload => {
  return {
    type: DMV_UPDATE_MILITARY_STATUS,
    payload,
  };
};

export const agencyAppRequest = () => {
  return async function(dispatch) {
    const [res, err] = await to(dispatch(getAppFromId()));
    if (err) return Promise.reject(err);
    return Promise.resolve(res);
  };
};

export const verify = payload => {
  return async function(dispatch, getStore) {
    const store = getStore();
    const registration = store.dmv.appProfile;
    const { userKey, appId, plateNumber, vin } = registration;
    const lastFourVin = vin.trim().slice(-4);
    const userKeys = [userKey];
    const { data } = payload;
    // populating values from the lookup call
    const dataWithVehicleInfo = data.map(v => {
      if (v.name === 'plateNumber') {
        return { ...v, value: plateNumber.trim() };
      } else if (v.name === 'lastFourOfVIN') {
        return { ...v, value: lastFourVin };
      }
    });

    const requestBody = {
      appId,
      userKeys,
      transactionId: APP_TRANSACTION_IDS.BASIC_INFO,
      params: dataWithVehicleInfo,
    };
    const [res, err] = await to(dispatch(verifyRenewalNotice(requestBody)));
    if (err) return Promise.reject(err);
    return Promise.resolve(res);
  };
};

export const verifyRenewalFlow = payload => {
  return async function(dispatch, getStore) {
    const store = getStore();
    const registration = store.dmv.selected;
    const { userKey, appId, plateNumber, vin } = registration;
    const lastFourVin = vin.trim().slice(-4);
    const userKeys = [userKey];
    const { data } = payload;
    // populating values from the lookup call
    const dataWithVehicleInfo = data.map(v => {
      if (v.name === 'plateNumber') {
        return { ...v, value: plateNumber.trim() };
      } else if (v.name === 'lastFourOfVIN') {
        return { ...v, value: lastFourVin };
      }
    });

    const requestBody = {
      appId,
      userKeys,
      transactionId: APP_TRANSACTION_IDS.BASIC_INFO,
      params: dataWithVehicleInfo,
    };
    const [res, err] = await to(dispatch(verifyRenewalNotice(requestBody)));
    if (err) return Promise.reject(err);
    return Promise.resolve(res);
  };
};

export const ernoUpdated = () => {
  return async function(dispatch, getStore) {
    const store = getStore();
    const registration = store.dmv.appProfile;
    const {
      userKey,
      appId,
      vin,
      plateNumber,
      documentNumber,
      agencyId,
    } = registration;
    const transactionInfo = {
      vehicleDetails: {
        documentNumber,
        vin,
        renewalNoticeCd: store.dmv.appProfile.ernoNoticeChoice,
        plateNumber,
        expirationDate: store.dmv.appProfile.expirationDate,
        vehicleMake: store.dmv.appProfile.vehicleMake,
        vehicleModelYear: store.dmv.appProfile.vehicleModelYear,
      },
    };

    const userKeys = [userKey];

    const requestBody = {
      appId,
      userKeys,
      transactionInfo,
      agencyId,
      transactionId: APP_TRANSACTION_IDS.ERNOUPDATE,
    };

    const [{ body }, err] = await to(dispatch(ernoUpdate(requestBody)));
    if (body.errors) return Promise.reject(body);
    if (err) return Promise.reject(err);
    return Promise.resolve(body);
  };
};

export const updateImcNo = payload => {
  return {
    type: DMV_UPDATE_IMC_NO,
    payload,
  };
};

export const updateMailingAddress = payload => {
  return {
    type: DMV_UPDATE_MAILING_ADDRESS,
    payload,
  };
};

export const storeInsuranceInfo = payload => {
  return async function(dispatch) {
    dispatch({
      type: DMV_STORE_APP_INSURANCE,
      payload,
    });
  };
};

export const storeAppProfile = payload => {
  return {
    type: DMV_STORE_APP_PROFILE,
    payload,
  };
};

export const storeLookUp = payload => {
  return {
    type: DMV_STORE_LOOKUP,
    payload,
  };
};

export const storeCommercialVehicleIndicator = payload => dispatch => {
  dispatch({
    type: DMV_COMMERCIAL_VEHICLE,
    payload,
  });
};

export const saveCountyCode = payload => dispatch => {
  dispatch({
    type: DMV_STORE_COUNTY_CODE,
    payload,
  });
};

export const saveRenewalTerm = payload => dispatch => {
  dispatch({
    type: DMV_STORE_RENEWAL_TERM,
    payload,
  });
};

export const storeExemption = payload => dispatch => {
  dispatch({
    type: DMV_STORE_EXEMPTION,
    payload,
  });
};

export const getStickerStatus = () => {
  return async (dispatch, getStore) => {
    const store = getStore();

    const registration = store.dmv.appProfile;
    const { userKey, appId } = registration;

    const userKeys = [userKey];

    const requestBody = {
      appId,
      userKeys,
      transactionId: APP_TRANSACTION_IDS.STICKER_TRACKER,
    };

    const [{ body }, err] = await to(
      dispatch(lookupAppLinkRequest(requestBody))
    );
    if (err) return Promise.reject(err);
    return Promise.resolve(body.data);
  };
};

export const getEligibilityDMVRegistration = () => {
  return async function(dispatch, getStore) {
    const store = getStore();

    const registration = store.dmv.selected;
    const { userKey, appId, documentNumber } = registration;

    const userKeys = [userKey];

    const transactionInfo = {
      documentNumber,
    };

    const requestBody = {
      appId,
      userKeys,
      transactionId: APP_TRANSACTION_IDS.ELIGIBILITY_LOOKUP,
      transactionInfo,
    };

    const [{ body }, err] = await to(
      dispatch(lookupAppLinkRequest(requestBody))
    );

    if (body.errors) return Promise.resolve(body);

    if (err) return Promise.reject(err);

    dispatch(storeAppProfile(body.data));

    return Promise.resolve(body.data);
  };
};

export const calculateFeeAndAddressCheck = (zip, formikActions) => async (
  dispatch,
  getStore
) => {
  const { dmv } = getStore();
  const registration = dmv.selected;
  const { userKey, appId, documentNumber } = registration;
  const selfCertifiedIndicator = !dmv.appProfile.selfCertifiedIndicator
    ? 'false'
    : dmv.appProfile.selfCertifiedIndicator;
  const county = dmv.countyCode ? dmv.countyCode.county.value : null;
  const regAddlYrElgble =
    dmv.appProfile.regAddlYrElgble === 'true'
      ? dmv.renewalTerm && dmv.renewalTerm.userSelectedTwoYearRenewal
        ? 'true'
        : 'false'
      : undefined;
  const requestBody = {
    appId,
    userKeys: [userKey],
    transactionId: APP_TRANSACTION_IDS.FEE_CALCULATION,
    transactionInfo: {
      documentNumber,
      countyCode: county,
      zipCode: zip,
      selfCertifiedIndicator,
      regAddlYrElgble,
    },
  };

  const [{ response, body }, err] = await to(
    dispatch(lookupAppLinkRequest(requestBody))
  );
  const { renewalTerm } = dmv;
  const countyCode = county;
  dispatch(updateFeeDetails({ ...body.data, countyCode, renewalTerm }));

  if (checkRequestFailure({ response, body })) {
    handleRequestFailure(body, formikActions);
    return Promise.reject();
  }

  if (body.errors) {
    return Promise.resolve(body);
  }

  if (err) {
    return Promise.reject(err);
  }

  return Promise.resolve(body.data);
};

export const getUpdatedDMVFeeDetails = (countyCode, renewalTerm) => {
  return async function(dispatch, getStore) {
    const store = getStore();

    const registration = store.dmv.selected;
    const { userKey, appId, documentNumber } = registration;

    const {
      selfCertifiedIndicator,
      inspectionResult,
      isOutOfState,
      isVehicleCertified,
    } = store.dmv.appProfile;

    const userKeys = [userKey];

    const transactionInfo = {
      documentNumber,
      countyCode,
      ...(renewalTerm &&
        renewalTerm.userSelectedTwoYearRenewal && { regAddlYrElgble: 'true' }),
      selfCertifiedIndicator:
        selfCertifiedIndicator === 'true' &&
        inspectionResult === 'UNKNOWN' &&
        isOutOfState === 'false' &&
        isVehicleCertified === 'false'
          ? 'false'
          : 'true',
    };

    const requestBody = {
      appId,
      userKeys,
      transactionId: APP_TRANSACTION_IDS.FEE_CALCULATION,
      transactionInfo,
    };

    const [{ body }, err] = await to(
      dispatch(lookupAppLinkRequest(requestBody))
    );

    dispatch(updateFeeDetails({ ...body.data, countyCode, renewalTerm }));
    if (err) return Promise.reject(err);
    return Promise.resolve();
  };
};

export const clearDMVRRData = () => dispatch => {
  dispatch(clearAppData());
  return dispatch({ type: DMV_DMVRR_CLEAR_DATA });
};

export const setDMVFromDeepLink = (value: boolean) => dispatch =>
  dispatch({ type: DMV_SET_FROM_DEEP_LINK, payload: value });

export const submitDMVAddressChange = () => {
  return async function(dispatch, getStore) {
    const { dmv } = getStore();
    const registration = dmv.selected;
    const { userKey, appId, agencyId } = registration;

    const contDetails = dmv.appProfile.mailingAddress;

    const contactDetails = {
      firstName: contDetails.firstName || '',
      middleName: '',
      lastName: contDetails.lastName || '',
      suffix: '',
      entity: contDetails.businessName || '',
      customerType: contDetails.addressType,
      mailingAddress: {
        addressLine1: contDetails.streetAddress,
        addressLine2: contDetails.addressLine2 || '',
        city: contDetails.city,
        state: contDetails.state.value,
        zip: contDetails.zipFive,
        zip4: contDetails.zipFour || '',
      },
    };

    const vehicleDetails = {
      documentNumber: registration.documentNumber,
      vin: registration.vin,
      renewalNoticeCd: registration.renewalNoticeCd,
      plateNumber: registration.plateNumber,
      vehicleMake: registration.vehicleMake,
      vehicleModelYear: registration.vehicleModelYear,
      registrationExpiryMonth: registration.registrationExpiryMonth,
      registrationExpiryYear: registration.registrationExpiryYear,
    };

    const requestBody = {
      appId,
      userKeys: [userKey],
      agencyId,
      transactionId: APP_TRANSACTION_IDS.MAILADDRCHANGE,
      transactionInfo: {
        vehicleDetails,
        contactDetails,
      },
    };

    const [{ response, body }, err] = await to(
      dispatch(dmvAddressChangeTransactRequest(requestBody))
    );
    if (err) return Promise.reject(err);
    if (checkRequestFailure({ response, body })) return Promise.reject(body);
    return Promise.resolve(body);
  };
};

export function getLookUpDataAndRenewDMVRegistration({
  appId,
  userKeys,
  transactionId,
}) {
  return async function(dispatch) {
    const requestBody = {
      appId,
      userKeys,
      transactionId,
    };
    const [{ body }, err] = await to(
      dispatch(lookupAppLinkRequest(requestBody))
    );

    dispatch(storeLookUp(body.data));
    dispatch(
      renewDMVRegistration({
        ...body.data.profiles[0].account[0],
        userKey: body.data.profiles[0].userKey,
        appId,
        agencyId: DMV_AGENCY_ID,
      })
    );
    if (err) return Promise.reject(err);
    return Promise.resolve(body.data);
  };
}

export function getLookUpDataAndChangeDMVAddress({
  appId,
  userKeys,
  transactionId,
}) {
  return async function(dispatch) {
    const requestBody = {
      appId,
      userKeys,
      transactionId,
    };
    const [{ body }, err] = await to(
      dispatch(lookupAppLinkRequest(requestBody))
    );

    if (err) return Promise.reject(err);

    const profile = body.data.profiles[0];
    await dispatch(
      changeMailingAddress({
        ...profile.account[0],
        userKey: profile.userKey,
        appId,
        agencyId: DMV_AGENCY_ID,
      })
    );
    return Promise.resolve(body.data);
  };
}

export const verifyDMVMailingAddress = ({ values, formikActions }) => {
  return async dispatch => {
    const formValues = cloneObject(values);
    formValues.address = formatAddressFromForm(formValues);

    const [{ body, response }, err] = await to(
      dispatch(userVerifyAddressRequest(formValues.address))
    );

    if (checkRequestFailure({ response, body }))
      return handleRequestFailure(body, formikActions, ERRORS_MAP.ADDRESS);

    if (err) return Promise.reject(err);

    formikActions.setSubmitting(false);

    if (checkRequestFailure({ body, response })) {
      handleRequestFailure(body, formikActions, {
        'address.streetAddress': 'streetAddress',
        'address.addressLine2': 'addressLine2',
        'address.city': 'city',
        'address.state.value': 'state',
        'address.zipFive': 'zipFive',
      });

      return Promise.reject();
    }

    //A modified address was found...promp user which to use
    if (body.status === DMV_MELISA_CONTINUE) {
      dispatch(
        openModal('VerifyAddressModal/DMV', {
          enteredAddress: formValues.address,
          addressOptions: body.data,
        })
      );
    }

    //Action may be needed from user
    if (
      body.status === DMV_MELISA_WARNING ||
      body.status === DMV_MELISA_ERROR
    ) {
      switch (body.message) {
        case DMV_MELISA_ADDRESS_TWO_MISSING:
          dispatch(
            openModal('AddressTwoMissingModal/DMV', {
              enteredAddress: formValues.address,
              addressOptions: body.data,
            })
          );
          break;
        case DMV_MELISA_ADDRESS_TWO_INVALID:
          dispatch(
            openModal('AddressTwoIncorrectModal/DMV', {
              enteredAddress: formValues.address,
              addressOptions: body.data,
            })
          );
          break;
        case DMV_MELISA_ADDRESS_NOT_VERIFIED:
        case DMV_MELISA_INVALID_ADDRESS:
          dispatch(
            openModal('AddressCantConfirm/DMV', {
              enteredAddress: formValues.address,
            })
          );
          break;
        default:
          break;
      }
    }

    return Promise.resolve(body);
  };
};

export const formattDMVPayment = () => {
  return async function(dispatch, getStore) {
    const { dmv } = getStore();

    const { appProfile } = dmv;

    const registration = dmv.selected;
    const { userKey, appId, agencyId, vin } = registration;

    const userKeys = [userKey];

    const contDetails = dmv.appProfile.mailingAddress;

    const contactDetails = {
      fName: contDetails.firstName ? contDetails.firstName : '',
      mName: '',
      lName: contDetails.lastName ? contDetails.lastName : '',
      suffix: '',
      entity: contDetails.businessName ? contDetails.businessName : '',
      customerType: contDetails.addressType,
      userEmail: contDetails.email,
      phoneNum: contDetails.phoneNumber.replaceAll('-', ''),
      imcNo: dmv.appProfile.imcNo ? dmv.appProfile.imcNo : '',
      militaryStatusCode: resolveMilitaryStatusCode(
        dmv.appProfile.militaryStatusCode
      ),
      mailingAddress: {
        streetAddress: contDetails.streetAddress,
        addressLine2: contDetails.addressLine2 ? contDetails.addressLine2 : '',
        city: contDetails.city,
        zipFive: contDetails.zipFive,
        zipFour: contDetails.zipFour ? contDetails.zipFour : '',
        state: contDetails.state.value,
        deliveryPointCode: contDetails.deliveryPointCode
          ? contDetails.deliveryPointCode
          : '',
      },
    };

    const vehicleDetails = {
      documentNumber: dmv.appProfile.vehicle.documentNumber,
      expirationDate: dmv.appProfile.vehicle.expirationDate,
      majorColorCode: dmv.appProfile.vehicle.majorColorCode,
      minorColorCode: dmv.appProfile.vehicle.minorColorCode,
      vehicleMake: dmv.appProfile.vehicle.vehicleMake,
      vehicleModelYear: dmv.appProfile.vehicle.vehicleModelYear,
      vin,
      renewalNoticeCd: dmv.appProfile.ernoNoticeChoice,
      affidavitReason: dmv.appProfile.affidavitReason,
    };

    const appInsuranceDetails = dmv.appProfile.insuranceDetails;
    let insuranceDetailsLog;

    if (appInsuranceDetails != null) {
      insuranceDetailsLog = `--Start BeforeFormat--`;
      insuranceDetailsLog += `, companyName: ${appInsuranceDetails.companyName}`;
      insuranceDetailsLog += `, policyNumber: ${appInsuranceDetails.policyNumber}`;
      insuranceDetailsLog += `, agentName: ${appInsuranceDetails.agentName}`;
      insuranceDetailsLog += `, phoneNumber: ${appInsuranceDetails.phoneNumber}`;
      insuranceDetailsLog += `, policyStartDate: ${appInsuranceDetails.policyStartDate}`;
      insuranceDetailsLog += `, policyExpirationDate: ${appInsuranceDetails.policyExpirationDate}`;
      insuranceDetailsLog += `--End BeforeFormat--`;
    }

    //Need to send everytime, issue with DMV services
    const insuranceDetails = {
      companyName: appInsuranceDetails
        ? appInsuranceDetails.companyName
        : '',
      policyNumber: appInsuranceDetails
        ? appInsuranceDetails.policyNumber
        : '',
      agentName: appInsuranceDetails
        ? appInsuranceDetails.agentName
        : '',
      phoneNumber: appInsuranceDetails
        ? appInsuranceDetails.phoneNumber.replaceAll('-', '')
        : '',
      policyStartDate: appInsuranceDetails
        ? moment(appInsuranceDetails.policyStartDate, 'MM/DD/YYYY').format(
            'YYYYMMDD'
          )
        : '', // yyyymmdd,
      policyExpirationDate: appInsuranceDetails
        ? moment(appInsuranceDetails.policyExpirationDate, 'MM/DD/YYYY').format(
            'YYYYMMDD'
          )
        : '',
    };

    if (insuranceDetailsLog) {
      insuranceDetailsLog += `\n--Start AfterFormat--`;
      insuranceDetailsLog += `, companyName: ${insuranceDetails.companyName || 'undefined'}`;
      insuranceDetailsLog += `, policyNumber: ${insuranceDetails.policyNumber || 'undefined'}`;
      insuranceDetailsLog += `, agentName: ${insuranceDetails.agentName || 'undefined'}`;
      insuranceDetailsLog += `, phoneNumber: ${insuranceDetails.phoneNumber || 'undefined'}`;
      insuranceDetailsLog += `, policyStartDate: ${insuranceDetails.policyStartDate || 'undefined'}`;
      insuranceDetailsLog += `, policyExpirationDate: ${insuranceDetails.policyExpirationDate || 'undefined'}`;
      insuranceDetailsLog += `--End AfterFormat--`;
    }

    const transactionInfo = {
      feeDetails: dmv.appProfile.feeDetails,
      donationDetails: dmv.appProfile.donationDetails,
      vehicleDetails,
      contactDetails,
      insuranceDetails,
      ...(insuranceDetailsLog && { insuranceDetailsLog }),
      countyCode: dmv.appProfile.countyCode,
      paymentToken: '',
      paymentAccountId: '',
      paymentAccountType: '',
      ...(appProfile.regAddlYrElgble === 'true' && {
        regAddlYrElgble: dmv.renewalTerm
          ? dmv.renewalTerm.userSelectedTwoYearRenewal
          : 'false',
      }),
    };

    return {
      userKeys,
      appId,
      agencyId,
      transactionId: APP_TRANSACTION_IDS.SUBMIT_RENEWAL_PAYMENT,
      transactionInfo,
    };
  };
};
